import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Popover, Card, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import Parameters from 'shared/parameters';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import { CurrencyFormatter, GetOrderTag } from 'shared/services/Utility';
import arrowLeft from '../../../src/img/arrow-left.png';
import { AuthConsumer } from 'shared/contexts/AuthContext';

interface Props {
    location: any;
}

const { Title, Link } = Typography;
const { confirm } = Modal;
const { Option } = Select;
export default function OrdersReport(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [selectedOrg, setSelectedOrg] = useState(null as any);
    const [pagination, setPagination] = useState({ page: 1, per_page: '50' } as any);
    const [total, setTotal] = useState(0);
    const [items, setItems] = useState([] as any[]);
    const [organizations, setOrganizations] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const columns = [
        {
            title: t('genDict.paymentMethod'),
            key: 'paymentMethod',
            dataIndex: 'payment_method',
        },
        {
            title: t('genDict.transactionId'),
            key: 'payments_transaction_id',
            dataIndex: 'payments_transaction_id',
        },
        {
            title: t('genDict.email'),
            key: 'email',
            dataIndex: 'email',
        },
        {
            title: t('genDict.price'),
            key: 'price',
            dataIndex: 'price',
            render: (a: string) => CurrencyFormatter.format(parseFloat(a)),
        },
        {
            title: t('genDict.salePrice'),
            key: 'sale_price',
            dataIndex: 'sale_price',
            render: (a: string) => CurrencyFormatter.format(parseFloat(a)),
        },
        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
        {
            title: t('report.order_status'),
            key: 'order_status',
            dataIndex: 'order_status',
            render: (a: any) => a ? GetOrderTag(a.name) : '-',
        },
        {
            title: t('genDict.items'),
            key: 'items',
            dataIndex: 'items',
            render: (a: any[]) => a.map((i: any) => {
                return i.product ? (i.product.title || i.product.name) : '-';
            }).join(', '),
        },
    ];


    const refreshItems = () => {
        setFetching(true);
        console.log(JSON.stringify(pagination), pagination);
        API_SERVICE.fetchReports({
            ...pagination,
            filter_organization_id: selectedOrg,
            order: 'DESC',
            order_by: 'id',
        }, 'orders').then(({
                               data: {
                                   data: {
                                       count,
                                       current_page,
                                       items,
                                       per_page,
                                       total,
                                   },
                               },
                           }) => {
            setItems(items);
            setTotal(total);
        }).catch(e => {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        }).finally(() => {
            setFetching(false);

        });
    };
    const fetchOrganizations = async () => {
        try {
            const {
                data: {
                    data: {
                        items: o,
                    },
                },
            } = await API_SERVICE.fetchOrganizations({ per_page: 1000, order_by: 'id', page: 1, order: 'DESC' });
            setOrganizations(o);
            if (o.length) {
                setSelectedOrg(o[0].id);
            }
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {

        }
    };
    useEffect(() => {
        if (Parameters.Mode === 'SUPER_ADMIN') {
            fetchOrganizations();
        } else {
            refreshItems();
        }
    }, []);
    useEffect(() => {
        if (selectedOrg) {
            refreshItems();
        }
    }, [selectedOrg, pagination, props.location]);
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                <div className={'list-page-wrapper'}>
                    {/* <Row gutter={20} justify={'space-between'}>
                        <Col flex={'auto'}>
                            <Title level={3}>{t('genDict.ordersReport')}</Title>
                        </Col>
                        <Col>
                            {
                                Parameters.Mode === 'SUPER_ADMIN' && <Select value={selectedOrg} onChange={(e) => {
                                    setSelectedOrg(e);
                                    setPagination({ ...pagination, page: 1, total: 0 });
                                }
                                }>
                                    {
                                        organizations.map((o: any) => {
                                            return <Option value={o.id}>{o.name}</Option>;
                                        })
                                    }
                                </Select>
                            }
                        </Col>
                    </Row> */}
                    <div className="container-fluid">
                        <div className='row mb-3'>
                            <div className='col-md-12 p-0 d-flex align-items-center'>
                                <div className='mr-4'>
                                <span className='bg-back cursor-pointer' onClick={() => history.goBack()}><img src={arrowLeft} className="page-back" /></span>
                                </div>
                                <div><h3 className='mb-0'>{t('genDict.ordersReport')}</h3></div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 p-0'>
                                <div className='bg-white p-3 br-5px'>
                                    <div className="row">
                                        <div className="col-md-12 pb-3">
                                            <div className="table-responsive table-br-5 box-shadow mt-2">
                                                <table className="table table-meetings">
                                                    <thead>
                                                        <tr>
                                                        <th className="text-uppercase text-secondary">{t('genDict.course')}</th>
                                                        {/* <th className="text-uppercase text-secondary">Transaction id</th> */}
                                                        <th className="text-uppercase text-secondary">{t('genDict.payment_method')}</th>
                                                        <th className="text-uppercase text-secondary">{t('genDict.email')}</th>
                                                        <th className="text-uppercase text-secondary">{t('genDict.price')}</th>
                                                        <th className="text-uppercase text-secondary">{t('genDict.SellingPrice')}</th>
                                                        <th className="text-uppercase text-secondary">{t('genDict.PurchaseDate')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            items && items.map((item :any) => {
                                                                console.log('orderItem',item);
                                                                return <tr>
                                                                    <td style={{width: '300px'}}>
                                                                    {item.items && item.items.map((itemCourse: any) =>{
                                                                        return <>
                                                                            <span className={`${itemCourse.product.deleted_at !== null ? 'text-secondary':''}`}>{itemCourse?.product?.title ? itemCourse.product.title+ ', ': ''}</span>
                                                                            </>
                                                                        
                                                                    })}
                                                                    </td>
                                                                    {/* <td className="text-secondary">{item.payments_transaction_id}</td> */}
                                                                    <td className="text-secondary">{item.payment_method}</td>
                                                                    <td className="text-secondary">{item.email}</td>
                                                                    <td className="text-secondary">{item.price}</td>
                                                                    <td>{item.sale_price}</td>
                                                                    <td className="text-secondary">{moment(item.created_at).format('DD MMMM, YYYY')}</td>
                                                                </tr>
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <Table loading={fetching} scroll={{ x: true }} pagination={{
                        onChange: (page, per_page) => {
                            setPagination({ ...pagination, page: page, per_page: per_page || pagination.per_page });
                        },
                        pageSize: pagination.per_page,
                        hideOnSinglePage: true,
                        total: total,
                    }} dataSource={items} columns={columns}/> */}
                </div>
                )
            }
        </AuthConsumer>
    );
}
